import React from 'react';
import './Sub.css';

class Sub extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            // Initialize any state variables if needed
        };
    }
    render() {
        return (
            <div className={'sub_section'}>
                <h2>{this.props.title}</h2>
                <div className={'sub_section_content'}>
                    {this.props.subContent}
                </div>
            </div>
        );
    }
}
export default Sub;